export function setCookie(name, value, { days = 365, path = "/", sameSite = "Lax" } = {}) {
  if (typeof document === "undefined") return;
  const safeName = encodeURIComponent(String(name || ""));
  const safeValue = encodeURIComponent(String(value ?? ""));

  const maxAge = Math.max(0, Math.floor(days * 24 * 60 * 60));
  const secure = typeof window !== "undefined" && window.location?.protocol === "https:" ? "; Secure" : "";

  document.cookie = `${safeName}=${safeValue}; Max-Age=${maxAge}; Path=${path}; SameSite=${sameSite}${secure}`;
}

export function getCookie(name) {
  if (typeof document === "undefined") return null;
  const target = `${encodeURIComponent(String(name || ""))}=`;
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (const part of parts) {
    if (part.startsWith(target)) {
      const raw = part.slice(target.length);
      try {
        return decodeURIComponent(raw);
      } catch {
        return raw;
      }
    }
  }
  return null;
}

